
/* ===== next script block ===== */


(function() {
  'use strict';

  // Tag the body so template-scoped CSS in loryx-product.css can target this page.
  if (document.getElementById('loryx-product-page')) {
    document.body.classList.add('loryx-alternate-page');
  }

  // ---- LEGACY: custom gallery dots/thumbnails (only if old static gallery is present) ----
  (function () {
    const track = document.getElementById('galleryTrack');
    const dots = document.getElementById('galleryDots');
    const thumbs = document.querySelectorAll('.loryx-gallery__thumb');
    if (!track || !dots) return; // Native Shopify gallery is in use; skip.
    const slides = track.querySelectorAll('.loryx-gallery__slide');

    dots.innerHTML = '';
    slides.forEach((c, i) => {
      const d = document.createElement('div');
      d.className = 'loryx-gallery__dot';
      if (i === 0) d.classList.add('active');
      d.addEventListener('click', () => c.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }));
      dots.appendChild(d);
    });

    const allDots = dots.querySelectorAll('.loryx-gallery__dot');
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const idx = Array.from(slides).indexOf(e.target);
          allDots.forEach(d => d.classList.remove('active'));
          if (allDots[idx]) allDots[idx].classList.add('active');
        }
      });
    }, { root: track, threshold: 0.6 });
    slides.forEach(c => obs.observe(c));

    function showSlide(idx) {
      slides.forEach((s, i) => s.classList.toggle('desktop-active', i === idx));
      thumbs.forEach((t, i) => t.classList.toggle('active', i === idx));
      const img = slides[idx].querySelector('.loryx-gallery__img');
      if (img) {
        img.style.opacity = '0';
        img.offsetHeight;
        img.style.transition = 'opacity 0.3s ease';
        img.style.opacity = '1';
      }
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', function() {
        showSlide(parseInt(this.dataset.index));
      });
    });
  })();

  // VIDEO CAROUSEL DOTS
  (function() {
    var track = document.getElementById('videosTrack');
    var dots = document.getElementById('videoDots');
    var prev = document.getElementById('videoPrev');
    var next = document.getElementById('videoNext');
    if (!track || !dots) return;
    var cards = track.querySelectorAll('.loryx-videos__card');
    dots.innerHTML = '';
    cards.forEach(function(c, i) {
      var d = document.createElement('div');
      d.className = 'loryx-videos__dot';
      if (i === 0) d.classList.add('active');
      d.addEventListener('click', function() { c.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); });
      dots.appendChild(d);
    });
    var allDots = dots.querySelectorAll('.loryx-videos__dot');
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          var idx = Array.from(cards).indexOf(e.target);
          allDots.forEach(function(d) { d.classList.remove('active'); });
          if (allDots[idx]) allDots[idx].classList.add('active');
        }
      });
    }, { root: track, threshold: 0.6 });
    cards.forEach(function(c) { obs.observe(c); });
    if (prev) prev.addEventListener('click', function() { track.scrollBy({ left: 350, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function() { track.scrollBy({ left: -350, behavior: 'smooth' }); });
  })();

  // VIDEO PLAY/PAUSE
  document.querySelectorAll('.loryx-videos__video-wrapper').forEach(function(wrapper) {
    var video = wrapper.querySelector('.loryx-videos__real-video');
    var playBtn = wrapper.querySelector('.loryx-videos__play-btn');
    if (!video) return;
    wrapper.addEventListener('click', function() {
      if (video.paused) {
        document.querySelectorAll('.loryx-videos__real-video').forEach(function(v) {
          v.pause();
          v.parentElement.querySelector('.loryx-videos__play-btn').style.opacity = '1';
        });
        video.play();
        playBtn.style.opacity = '0';
      } else {
        video.pause();
        playBtn.style.opacity = '1';
      }
    });
    video.addEventListener('ended', function() { playBtn.style.opacity = '1'; });
  });

  // BEFORE/AFTER SLIDER
  (function() {
    var slider = document.getElementById('baSlider');
    if (!slider) return;
    var afterImg = slider.querySelector('.loryx-ba__img--after');
    var line = slider.querySelector('.loryx-ba__line');
    var handle = slider.querySelector('.loryx-ba__handle');
    var isDragging = false;

    function setPosition(x) {
      var rect = slider.getBoundingClientRect();
      var pct = ((x - rect.left) / rect.width) * 100;
      pct = Math.max(5, Math.min(95, pct));
      afterImg.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      line.style.left = pct + '%';
      handle.style.left = pct + '%';
    }

    slider.addEventListener('mousedown', function(e) { isDragging = true; setPosition(e.clientX); e.preventDefault(); });
    window.addEventListener('mousemove', function(e) { if (isDragging) setPosition(e.clientX); });
    window.addEventListener('mouseup', function() { isDragging = false; });
    slider.addEventListener('touchstart', function(e) { isDragging = true; setPosition(e.touches[0].clientX); }, { passive: true });
    slider.addEventListener('touchmove', function(e) { if (isDragging) { setPosition(e.touches[0].clientX); e.preventDefault(); } }, { passive: false });
    slider.addEventListener('touchend', function() { isDragging = false; });
  })();

  // REVIEWS CAROUSEL DOTS
  (function() {
    var track = document.getElementById('reviewsTrack');
    var dots = document.getElementById('reviewDots');
    var prev = document.getElementById('reviewPrev');
    var next = document.getElementById('reviewNext');
    if (!track || !dots) return;
    var cards = track.querySelectorAll('.loryx-reviews__card');
    dots.innerHTML = '';
    cards.forEach(function(c, i) {
      var d = document.createElement('div');
      d.className = 'loryx-reviews__dot';
      if (i === 0) d.classList.add('active');
      d.addEventListener('click', function() { c.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); });
      dots.appendChild(d);
    });
    var allDots = dots.querySelectorAll('.loryx-reviews__dot');
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          var idx = Array.from(cards).indexOf(e.target);
          allDots.forEach(function(d) { d.classList.remove('active'); });
          if (allDots[idx]) allDots[idx].classList.add('active');
        }
      });
    }, { root: track, threshold: 0.6 });
    cards.forEach(function(c) { obs.observe(c); });
    if (prev) prev.addEventListener('click', function() { track.scrollBy({ left: 290, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function() { track.scrollBy({ left: -290, behavior: 'smooth' }); });

    // READ MORE buttons for truncated reviews
    cards.forEach(function(card) {
      var textEl = card.querySelector('.loryx-reviews__text');
      if (!textEl) return;
      var btn = document.createElement('button');
      btn.className = 'loryx-reviews__readmore';
      btn.type = 'button';
      btn.textContent = 'קרא עוד';
      textEl.parentNode.insertBefore(btn, textEl.nextSibling);
      function check() {
        if (textEl.classList.contains('expanded')) return;
        if (textEl.scrollHeight > textEl.clientHeight + 1) {
          btn.classList.add('visible');
        } else {
          btn.classList.remove('visible');
        }
      }
      btn.addEventListener('click', function() {
        var expanded = textEl.classList.toggle('expanded');
        btn.textContent = expanded ? 'קרא פחות' : 'קרא עוד';
      });
      check();
      window.addEventListener('resize', check);
    });
  })();



  // FULL REVIEWS (Loox) — filter + show more
  (function() {
    var list = document.getElementById('reviewList');
    if (!list) return;

    // Reorder: cards WITH images first, then cards without — preserving rating order within each group.
    (function reorderImagesFirst() {
      var allCards = Array.from(list.querySelectorAll('.lrv__card'));
      var withImg = allCards.filter(function (c) {
        var img = c.querySelector('.lrv__card-img');
        if (!img) return false;
        // Treat as "has image" only if a background image URL is actually present.
        var bg = img.getAttribute('style') || '';
        return /url\(/i.test(bg);
      });
      var withoutImg = allCards.filter(function (c) { return withImg.indexOf(c) === -1; });
      withImg.concat(withoutImg).forEach(function (c) { list.appendChild(c); });
    })();

    var cards = list.querySelectorAll('.lrv__card');
    var bars = document.querySelectorAll('.lrv__bar');
    var filterInfo = document.getElementById('filterInfo');
    var filterText = document.getElementById('filterText');
    var filterClear = document.getElementById('filterClear');
    var moreBtn = document.getElementById('moreBtn');
    var moreWrap = document.getElementById('moreWrap');
    var currentFilter = null;
    var visibleCount = 6;

    function applyFilter() {
      var shown = 0;
      var total = 0;
      cards.forEach(function(card) {
        var r = parseInt(card.dataset.rating);
        var matchesFilter = !currentFilter || r === currentFilter;
        if (matchesFilter) {
          total++;
          if (total <= visibleCount) {
            card.classList.remove('hidden');
            shown++;
          } else {
            card.classList.add('hidden');
          }
        } else {
          card.classList.add('hidden');
        }
      });
      if (currentFilter) {
        filterInfo.classList.add('show');
        filterText.textContent = 'מציג ' + total + ' ביקורות של ' + currentFilter + ' כוכבים';
      } else {
        filterInfo.classList.remove('show');
      }
      if (total > visibleCount) {
        moreWrap.style.display = 'block';
        moreBtn.textContent = 'הצג עוד (' + (total - visibleCount) + ' נוספות)';
      } else {
        moreWrap.style.display = 'none';
      }
      bars.forEach(function(b) {
        b.classList.toggle('active', parseInt(b.dataset.filter) === currentFilter);
      });
    }

    bars.forEach(function(bar) {
      bar.addEventListener('click', function() {
        var rating = parseInt(this.dataset.filter);
        currentFilter = currentFilter === rating ? null : rating;
        visibleCount = 6;
        applyFilter();
      });
    });
    filterClear.addEventListener('click', function() {
      currentFilter = null;
      visibleCount = 6;
      applyFilter();
    });
    moreBtn.addEventListener('click', function() {
      visibleCount += 10;
      applyFilter();
    });
    applyFilter();
  })();

  // STICKY CTA
  (function() {
    var sticky = document.getElementById('stickyCta');
    var closeSt = document.getElementById('closeSticky');
    if (!sticky) return;
    var dismissed = false;
    window.addEventListener('scroll', function() {
      if (dismissed) return;
      if (window.scrollY > window.innerHeight * 2.5) {
        sticky.classList.add('show');
      } else {
        sticky.classList.remove('show');
      }
    });
    if (closeSt) closeSt.addEventListener('click', function() {
      sticky.classList.remove('show');
      dismissed = true;
    });
  })();

  // STATISTICS — count up animation
  (function() {
    var section = document.getElementById('statsSection');
    if (!section) return;

    function countUp(el, target, isDecimal, duration) {
      var startTime = null;
      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        // Exponential ease-out: fast start, very slow elegant finish
        var eased = 1 - Math.pow(1 - progress, 4);
        var current = eased * target;
        if (isDecimal) {
          el.childNodes[0].textContent = (Math.round(current * 10) / 10).toFixed(1);
        } else {
          el.childNodes[0].textContent = Math.round(current).toString();
        }
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    var observer = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) {
        section.querySelectorAll('.loryx-stats__item').forEach(function(item, i) {
          var num = item.querySelector('.loryx-stats__number');
          var text = item.querySelector('.loryx-stats__text');
          setTimeout(function() {
            num.classList.add('visible');
            text.classList.add('visible');
            var target = parseFloat(num.dataset.target);
            var isDecimal = num.dataset.decimal === 'true';
            countUp(num, target, isDecimal, 2800);
          }, i * 350);
        });
        observer.disconnect();
      }
    }, { threshold: 0.3 });
    observer.observe(section);
  })();

  // FAQ ACCORDION
  (function() {
    document.querySelectorAll('.loryx-faq__question').forEach(function(q) {
      q.addEventListener('click', function() {
        var item = this.parentElement;
        var wasOpen = item.classList.contains('open');
        // Close all
        document.querySelectorAll('.loryx-faq__item').forEach(function(i) { i.classList.remove('open'); });
        // Toggle clicked
        if (!wasOpen) item.classList.add('open');
      });
    });
  })();

})();


/* ===== next script block ===== */


(function brandWordmark(){
  // Wrap every plain "soft 3 pro" text node with <span class="lx-word">soft 3 pro</span>
  const SKIP = new Set(['SCRIPT','STYLE','TEXTAREA','INPUT','CODE','PRE']);
  const RE = /(soft 3 pro|loryx|LŌRYX|LORYX|Lōryx|Loryx)/g;
  function walk(node){
    if (!node) return;
    if (node.nodeType === 3){
      const t = node.nodeValue;
      if (!t || !RE.test(t)) return;
      RE.lastIndex = 0;
      const frag = document.createDocumentFragment();
      let last = 0, m;
      while ((m = RE.exec(t)) !== null){
        if (m.index > last) frag.appendChild(document.createTextNode(t.slice(last, m.index)));
        const span = document.createElement('span');
        span.className = 'lx-word';
        span.textContent = m[0];
        frag.appendChild(span);
        last = m.index + m[0].length;
      }
      if (last < t.length) frag.appendChild(document.createTextNode(t.slice(last)));
      node.parentNode.replaceChild(frag, node);
      return;
    }
    if (node.nodeType !== 1) return;
    if (SKIP.has(node.tagName)) return;
    if (node.classList && node.classList.contains('lx-word')) return;
    // walk children (snapshot first since we replace text nodes)
    const kids = Array.from(node.childNodes);
    kids.forEach(walk);
  }
  function run(){ walk(document.body); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();


/* ===== next script block ===== */


(function scrollReveal(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  // Auto-tag candidates: cards & callouts
  const SELECTORS = [
    '.loryx-vp__card', '.loryx-hygiene__card', '.loryx-freedom__card',
    '.loryx-usage__step', '.loryx-product__card', '.loryx-motor__card',
    '.loryx-photos__card', '.loryx-faq__item',
    '.loryx-stats__item', '.loryx-compare__row', '.lrv-card'
  ];
  function tag(){
    document.querySelectorAll(SELECTORS.join(',')).forEach(el => {
      if (!el.classList.contains('reveal-up')) el.classList.add('reveal-up');
    });
  }
  function init(){
    tag();
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting){
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal-up').forEach(el => io.observe(el));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  setTimeout(tag, 500);
})();


/* ===== next script block ===== */


// ==========================================
// FAQ accordion (lx-faq)
// ==========================================
(function lxFaqAccordion(){
  function setupItem(item){
    if (item.dataset.lxFaqReady === '1') return;
    item.dataset.lxFaqReady = '1';
    const btn  = item.querySelector('.lx-faq__btn');
    const body = item.querySelector('.lx-faq__body');
    if (!btn || !body) return;

    btn.addEventListener('click', () => {
      const isOpen = item.classList.contains('active');
      if (isOpen) {
        body.style.maxHeight = '0px';
        item.classList.remove('active');
      } else {
        item.classList.add('active');
        // measure target height
        body.style.maxHeight = body.scrollHeight + 'px';
        // after open, allow content reflow (e.g. images)
        setTimeout(() => {
          if (item.classList.contains('active')) {
            body.style.maxHeight = body.scrollHeight + 'px';
          }
        }, 380);
      }
    });
  }
  function init(){
    document.querySelectorAll('.lx-faq__item').forEach(setupItem);

    // Re-measure open items on resize (orientation change, font swap)
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.querySelectorAll('.lx-faq__item.active .lx-faq__body').forEach(b => {
          b.style.maxHeight = b.scrollHeight + 'px';
        });
      }, 120);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();



/* ===== Smooth-scroll Final CTA → BundleUp widget at top of page ===== */
(function () {
  function findScrollTarget() {
    // Scroll to the mini-review area — the bundle widget sits right below it.
    var miniReview = document.querySelector('.loryx-info');
    if (miniReview) return miniReview;
    // Fallback: top of main product section
    var main = document.querySelector('main-product, .main-product, [id*="MainProduct"], #MainContent .product, #MainContent .shopify-section, #MainContent');
    if (main) return main;
    return null;
  }

  function bind(btn) {
    if (btn.dataset.loryxCtaBound === '1') return;
    btn.dataset.loryxCtaBound = '1';
    if (btn.tagName === 'A') btn.setAttribute('href', '#');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var target = findScrollTarget();
      if (target) {
        // Account for sticky header by offsetting a bit
        var rect = target.getBoundingClientRect();
        var top = rect.top + window.pageYOffset - 80;
        window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-copy="final_cta_btn"], [data-copy="sticky_btn"], .loryx-final__button, .loryx-sticky__btn').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-bind once for BundleUp late injection
  setTimeout(init, 500);
})();

/* ===== LAZY VIDEO LOAD + AUTOPLAY ON VIEWPORT (with carousel preloading) ===== */
(function lazyVideoAutoplay(){
  function loadVideo(v, eager) {
    if (v.dataset.loaded === '1') return;
    var src = v.getAttribute('data-src');
    if (!src) return;
    // Eager preload: aggressive download. Lazy: just metadata + first frames.
    if (eager) {
      v.setAttribute('preload', 'auto');
    } else {
      v.setAttribute('preload', 'metadata');
    }
    v.setAttribute('src', src);
    v.dataset.loaded = '1';
    try { v.load(); } catch(e) {}
  }

  // When ANY video in the carousel becomes the active one, preload it + the NEXT one
  function loadActiveAndNext(activeVideo) {
    var carousel = activeVideo.closest('#videosTrack, .loryx-videos__track');
    if (!carousel) {
      loadVideo(activeVideo, true);
      return;
    }
    var allVideos = carousel.querySelectorAll('video[data-src], .loryx-videos__real-video');
    var idx = Array.from(allVideos).indexOf(activeVideo);
    // Load current (eagerly) + next one (eagerly) + one after (metadata only)
    if (allVideos[idx])     loadVideo(allVideos[idx], true);
    if (allVideos[idx + 1]) loadVideo(allVideos[idx + 1], true);
    if (allVideos[idx + 2]) loadVideo(allVideos[idx + 2], false);
  }

  function init() {
    var videos = document.querySelectorAll('video[data-src]');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function(v){ loadVideo(v, true); });
      return;
    }

    // SECTION-LEVEL PRELOAD: When the videos carousel is approaching the viewport
    // (within 800px), eagerly load the FIRST 2 videos so they're ready
    // before the user scrolls into view.
    var videosSection = document.querySelector('.loryx-videos, #videosTrack');
    if (videosSection) {
      var sectionIo = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          var sectionVideos = videosSection.querySelectorAll('video[data-src]');
          if (sectionVideos[0]) loadVideo(sectionVideos[0], true);
          if (sectionVideos[1]) loadVideo(sectionVideos[1], true);
          if (sectionVideos[2]) loadVideo(sectionVideos[2], false);
          sectionIo.disconnect();
        }
      }, { rootMargin: '800px 0px 800px 0px' }); // Trigger 800px before/after
      sectionIo.observe(videosSection);
    }

    // PER-VIDEO observer: when a video is actually visible, play it +
    // preload the next one in the carousel.
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          loadActiveAndNext(v);
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function(){});
          var btn = v.parentElement && v.parentElement.querySelector('.loryx-videos__play-btn');
          if (btn) btn.style.opacity = '0';
        } else {
          if (!v.paused) v.pause();
          var btn2 = v.parentElement && v.parentElement.querySelector('.loryx-videos__play-btn');
          if (btn2) btn2.style.opacity = '1';
        }
      });
    }, { threshold: 0.5, rootMargin: '0px 0px -10% 0px' });

    videos.forEach(function(v) { io.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
